import React, { createContext, useContext, useState } from "react";
import { pricingData } from "../config/data";

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState({
    gender: "No answer",
    age: "No answer",
    skinConcerns: "No answer",
    skinType: "No answer",
    dailySkinCare: "No answer",
    skincareProductsUse: "No answer",
    useSunscreen: "No answer",
    location: "No answer",
    usedSkincareSulfates: "No answer",
    tiredSkincareWithAntioxidants: "No answer",
    usedSkincareAcids: "No answer",
    benefitsOfRetinolAndVitamin: "No answer",
    additionalConcerns: "No answer",
    moisturizedSkin: "No answer", 
    bothersYourSkin: "No answer",
    isSensitiveSkin: "No answer",
    sleepHours: "No answer",
    waterIntake: "No answer",
    stressLevel: "No answer",
    skincareRoutineTime: "No answer",
    improveWithSolvi: "No answer",
    confidenceGoal: "No answer",
    desiredFeeling: "No answer",
    solviOutcome: "No answer",
    challengeFindingProducts: "No answer",
    priceSensitive: "No answer",
    brandLoyal: "No answer",
    hypeDriven: "No answer",
    unsureApplication: "No answer",
    photo: "No answer",
    selectedOption: pricingData[1],
    email: "No answer",
  });

  const updateUserData = (newData) => {
    setUserData((prev) => ({
      ...prev,
      ...newData,
    }));
  };

  return (
    <UserContext.Provider value={{ userData, updateUserData }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
